import React, { useState, useEffect } from "react";
import moment from "moment";
import { DatePicker, Col } from "antd";

export const FormDatePicker = (props) => {

  const disabledDate = (current) => {
    // Can not select days before today and today
    return current < moment().add(3, "M").startOf("day");
  };
  return (
    <>
      {props.advisoryType == "More Than 3 Months" ? (
        <>
          <label>Date</label>
          <DatePicker
            className="formInput"
            style={{ width: "100%" }}
            name="validTill"
            // defaultValue={moment().set({ hour: 15, minute: 30 }).add(3, "M")}
            disabledDate={disabledDate}
            showTime
            placeholder="Select Time"
            onChange={props.onChange}
          />
        </>
      ) : (
        <div />
      )}
    </>
  );
};
